import { dom } from "#root/lib/dom";
export function prepareCanvas(canvas) {
  if (!canvas) canvas = dom("canvas", {
    class: "chart-canvas"
  });
  const ctx = canvas.getContext("2d");
  return {
    canvas,
    ctx
  };
}
export function patchCanvas2DContext() {
  // Add math round to all drawing functions
  const ctx = CanvasRenderingContext2D.prototype;
  const methodArgumentsToIgnore = {
    // types to ignore rounding for angles and other non-integer values
    // here list of all methods that have angle arguments
    arc: [3, 4],
    createConicGradient: [0],
    ellipse: [4, 5, 6],
    rotate: [0],
    scale: [0, 1],
    transform: true,
    // ignore all arguments
    setTransform: true // ignore all arguments

  };

  for (const key in ctx) {
    try {
      if (typeof ctx[key] === "function") {
        const original = ctx[key];

        ctx[key] = function () {
          for (let i = 0; i < arguments.length; i++) {
            if (typeof arguments[i] === "number" && methodArgumentsToIgnore[key] !== true && !(methodArgumentsToIgnore[key] || []).includes(i)) {
              arguments[i] = Math.round(arguments[i] * 100) / 100;
            }
          }

          return original.apply(this, arguments);
        };
      }
    } catch {}
  }
}